/**
 * Driver Support View API — read-only driver state + audit logging.
 * Delegates to client.js; returns raw Response for unchanged caller behavior.
 */

import { request } from "./client";

/**
 * Fetch read-only driver operational state for support view.
 * GET /admin/driver-view/{driver_id}
 * Returns: { driver, tasks, shift, location, odometer }
 * Requires: admin or dispatcher JWT token (handled automatically by request()).
 */
export function getDriverSupportView(driverId) {
  return request(`/admin/driver-view/${driverId}`, {
    authContext: { message: "Your session expired while loading the driver support view." },
  });
}

/**
 * Audit log entry for support view access.
 * POST /admin/audit/support-view
 * Body: { action: "start" | "end", driver_id: "..." }
 */
export function logSupportView(action, driverId) {
  return request("/admin/audit/support-view", {
    method: "POST",
    body: { action, driver_id: driverId },
    authContext: { message: "Your session expired while logging the support view." },
  });
}
